// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__auditFrame--olrIM {
  height: 100%;
  overflow: auto;
  background-color: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__title--TsD21 {
  padding: 20px 32px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__filterBox--gKzGA {
  padding: 0 32px 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__moreBox--WnHpi {
  padding: 1px 32px 0;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__box--h8IO1 {
  flex: 1;
  overflow: auto;
  padding: 0 32px;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__box--h8IO1 .ant-timeline {
  padding: 10px 0 0 0;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__content--L1EqT {
  min-height: 2rem;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__item--wkH43 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__time--cX1XA {
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  height: auto;
  text-align: left;
  padding: 0;
  color: #e43d00 !important;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__time--cX1XA:hover {
  background: transparent !important;
}
.ant-drawer-body .src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__time--cX1XA {
  color: #343a41 !important;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__fio--dlHaO {
  display: flex;
  flex-direction: row;
  gap: 4px;
  color: rgba(0, 0, 0, 0.55);
  background: none;
  border: none;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityCardPage/EntityHistory/EntityAudit/EntityAudit.module.less","webpack://./src/pages/EntityCardPage/EntityHistory/EntityAudit/EntityAuditList/EntityAuditList.module.less"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;ACDF;ADIA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFF;ADKA;EACE,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;ACHF;ADMA;EACE,mBAAA;ACJF;AArBA;EACE,OAAA;EACA,cAAA;EACA,eAAA;AAuBF;AA1BA;EAKI,mBAAA;AAwBJ;AArBA;EACE,gBAAA;AAuBF;AApBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAsBF;AAnBA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AAqBF;AAnBE;EACE,kCAAA;AAqBJ;AAjBA;EACE,yBAAA;AAmBF;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAkBF","sourcesContent":["@horizSpace: 32px;\n\n.auditFrame {\n  height: 100%;\n  overflow: auto;\n  background-color: white;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  padding: 20px @horizSpace;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n}\n\n.filterBox {\n  padding: 0 @horizSpace 24px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 16px;\n}\n\n.moreBox {\n  padding: 1px @horizSpace 0;\n}\n","@import \"../EntityAudit.module.less\";\n\n.box {\n  flex: 1;\n  overflow: auto;\n  padding: 0 @horizSpace;\n  :global(.ant-timeline) {\n    padding: 10px 0 0 0;\n  }\n}\n.content {\n  min-height: 2rem;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.time {\n  font-style: normal;\n  font-weight: 700;\n  line-height: 160%;\n  height: auto;\n  text-align: left;\n  padding: 0;\n  color: #e43d00 !important;\n\n  &:hover {\n    background: transparent !important;\n  }\n}\n\n:global(.ant-drawer-body) .time {\n  color: #343a41 !important;\n}\n\n.fio {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  color: rgba(0, 0, 0, 0.55);\n  background: none;\n  border: none;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auditFrame": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__auditFrame--olrIM`,
	"title": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__title--TsD21`,
	"filterBox": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__filterBox--gKzGA`,
	"moreBox": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__moreBox--WnHpi`,
	"box": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__box--h8IO1`,
	"content": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__content--L1EqT`,
	"item": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__item--wkH43`,
	"time": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__time--cX1XA`,
	"fio": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAuditList-EntityAuditList-module__fio--dlHaO`
};
export default ___CSS_LOADER_EXPORT___;
